module.exports = __webpack_public_path__ + "static/media/theoutcome_boardroom.f07bf90a.png";